// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3vjqy","linkContainer":"style_linkContainer__fytC9","socialIcon":"style_socialIcon__pn5wB"};